const cartDrawerObserver = new MutationObserver(function (mutationList, observer) {
  for (const mutation of mutationList) {
    if (mutation.type === "attributes") {
      console.log("test")
      BSS_B2B?.cart?.fixer(BSS_B2B.shopData, false, true);
    }
  }
});

document.addEventListener("DOMContentLoaded", function () {
  console.log('countdownElement', 'countdownElement')
  if (location.pathname.includes("/pages/thank-you-for-your-submission")) {
    console.log('countdownElement', 'countdownElement');
      (function(){
        let count = 5;
        const countdownElement = document.getElementById("bssCountdown");
        console.log('countdownElement', countdownElement)
        const interval = setInterval(() => {
            count--;
            countdownElement.textContent = count;
            if (count === 0) {
                clearInterval(interval);
                window.location.href = "/"; // Change this to your homepage URL if needed
            }
        }, 1000);
      })();
  }
  if (location.pathname.includes("/cart")) {
      setTimeout(function () {
        BSS_B2B.cart.fixer(BSS_B2B.shopData, false, false);
      }, 2000);
  } else {
    const cartDrawerContainer = document.querySelector(".drawer.cart__drawer");
    console.log(cartDrawerContainer)
    setTimeout(function () {
      cartDrawerObserver.observe(cartDrawerContainer, { attributes: true });
    }, 2000)
  }
});
